import { db } from "../schema.dexie";

/**
 * Guarda uma foto localmente como Blob no IndexedDB e devolve o id (ref local).
 * Nada sai do aparelho. Funciona no web e dentro do WebView do Capacitor.
 *
 * Obs.: para captura nativa polida (iOS/Android), trocar o <input type=file>
 * pelo plugin @capacitor/camera (já está nas dependências).
 */
export async function salvarFoto(blob: Blob): Promise<string> {
  const id = crypto.randomUUID();
  await db.foto.add({ id, blob, criado_em: new Date().toISOString() });
  return id;
}
